module.exports = __webpack_public_path__ + "static/1-006-fbeccfd5a939410510ed59b00e96b1f2.png";